module.exports = __webpack_public_path__ + "media/images/policy-bg-1440-43e5e5a0daf2db972e0eca0c491a06dc.png";